<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">

              <div class="row " id="slides">
                <!-- Work around to account for navigation height-->
                <div class="scroll-to-element" id="presentationSlides"></div>
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Presentation Slides
                  </h2>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                  <ul class="ml-3 mt-4">
                    <li class="mb-3">
                      <a href="/other/efcl_meeting_2022_09_slides.pdf">EFCL Huawei Meeting - 20.9.2022</a>
                    </li>
                    <li class="mb-3">
                      <a href="/other/EFCL_mini_conference_2022_05.pdf">EFCL Mini Conference - 23.5.2022</a>
                    </li>
                  </ul>
                </div>

                <!--
                <div class="col-12">
                </div>

                <div class="col-12">
                  <ul class="ml-3">
                    <li>
                      <a href="/other/efcl_meeting_2022_09_slides.pdf">EFCL Huawei Meeting - 20.9.2022</a>
                    </li>
                  </ul>
                </div>

                <div class="col-12">
                  <ul class="ml-3">
                    <li>
                      <a href="/other/EFCL_mini_conference_2022_05.pdf">EFCL Mini Conference - 23.5.2022</a>
                    </li>
                  </ul>
                </div>
                -->

              </div>

              <div class="m-5"></div>

              <div class="row " id="reports">
                <!-- Work around to account for navigation height-->
                <div class="scroll-to-element" id="technicalReport"></div>
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    Technical Report
                  </h2>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="container">
                  <div class="row mt-3 mb-3 align-items-top justify-content-between">
                    <div class="col-lg-4 col-md-4 home-about-left">
                      <center><a href="/pub_files/technical_report_dataset/EFCL_Dataset_Technical_Report-Broedermann+Bruggemann+Sakaridis+Van_Gool-2022_11.pdf" target="_blank">
                        <img class="img-fluid" src="/pub_files/technical_report_dataset/teaser.png" alt="">
                      </a></center>
                    </div>
  
                    <div class="col-lg-8 col-md-8 home-about-left">
                      <a href="/pub_files/technical_report_dataset/EFCL_Dataset_Technical_Report-Broedermann+Bruggemann+Sakaridis+Van_Gool-2022_11.pdf" target="_blank">
                        <h3>EFCL Dataset - Technical Report</h3>
                      </a>
  
                      <p>
                        <a href="https://scholar.google.com/citations?user=hzhMmjYAAAAJ&hl=en&oi=sra">Tim Brödermann</a>,
                        <a href="https://scholar.google.com/citations?user=uX2PrWMAAAAJ&hl=en&oi=ao">David Bruggemann</a>,
                        <a href="https://people.ee.ethz.ch/~csakarid/">Christos Sakaridis</a>, and
                        <a href="https://scholar.google.com/citations?user=TwMib_QAAAAJ&hl=en">Luc Van Gool</a> <br>
                        Technical report, 2022 <br>
                        <a href="/pub_files/technical_report_dataset/EFCL_Dataset_Technical_Report-Broedermann+Bruggemann+Sakaridis+Van_Gool-2022_11.pdf" target="_blank">Report</a>
                         · 
                        <a href="/pub_files/technical_report_dataset/technical_report_dataset_2022.bib" target="_blank">BibTeX</a>
                      </p>
                    </div>
                  </div>
                  <hr
                    class="divider-dark m-0 mb-1"
                    style="max-width: 100% !important"
                    size="2"
                    color="gray"
                  />
                </div>
              </div>

            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "MaterialsPage.vue",
  components: {
    NavigationMain
  }
};
</script>

